export function parents(node, condition = () => false) {
  var nodes = [node];
  for (; node; node = node.parentNode) {
    nodes.unshift(node);
    if(condition(node)) return nodes;
  }
  return nodes;
}

/**
 * 
 * @param {Node} node1 
 * @param {Node} node2 
 * @param {callback function} parentCondition 
 */
export default function findCommonAncestor(node1, node2, parentCondition = () => false) {
  if (node1 === node2) return node1;
  var parents1 = parents(node1, parentCondition);
  var parents2 = parents(node2, parentCondition);

  if (parents1[0] !== parents2[0]) return null;

  for (var i = 1; i < parents1.length; i++) {
    if (parents1[i] !== parents2[i]) return parents1[i - 1];
  }
  return node1;
}
